import axios from "axios";

// Service wrapper for the Explore page: open job postings + small businesses
// with a published problem statement. Calls filter query params directly
// (django-filter params aren't in the generated OpenAPI schema).
export const ExploreApi = {
  async jobs({ search, job_type, is_remote, limit = 6, offset = 0 } = {}) {
    const params = { limit, offset, ordering: "-created_at" };
    if (search) params.title = search;
    if (job_type) params.job_type = job_type;
    if (is_remote !== undefined && is_remote !== "")
      params.is_remote = is_remote;
    const res = await axios.get("/api/jobprofile/", {
      params,
      withCredentials: true,
    });
    return res.data;
  },

  async businesses({ search, limit = 24, offset = 0 } = {}) {
    const params = { limit, offset, has_problem: "true" };
    if (search) params.company_name = search;
    const res = await axios.get("/api/smallbiz-profile/", {
      params,
      withCredentials: true,
    });
    return res.data;
  },
};
